/** Shared Pitch record canvas / MediaRecorder targets (match 16:9 export masters). */

export const PITCH_RECORD_WIDTH = 1920;
export const PITCH_RECORD_HEIGHT = 1080;

/** ~12 Mbps VP8/VP9/H.264 for 1080p30 — browser default is often ~2.5 Mbps and looks soft after re-encode. */
export const PITCH_RECORD_VIDEO_BITRATE = 12_000_000;

export function evenDimension(n) {
  const v = Math.round(Number(n) || 0);
  if (v < 2) return 2;
  return v % 2 === 0 ? v : v - 1;
}

/**
 * Size the compose canvas from a screen-capture track.
 * Prefer native capture dims; cap the long edge at 1920 so exports stay sharp without huge WebMs.
 */
export function pitchComposeSizeFromCapture(videoWidth, videoHeight, {
  maxLongEdge = PITCH_RECORD_WIDTH,
  fallbackWidth = PITCH_RECORD_WIDTH,
  fallbackHeight = PITCH_RECORD_HEIGHT,
} = {}) {
  const sw = Math.max(0, Math.round(Number(videoWidth) || 0));
  const sh = Math.max(0, Math.round(Number(videoHeight) || 0));
  if (sw < 2 || sh < 2) {
    return { width: evenDimension(fallbackWidth), height: evenDimension(fallbackHeight) };
  }
  const long = Math.max(sw, sh);
  if (long <= maxLongEdge) {
    return { width: evenDimension(sw), height: evenDimension(sh) };
  }
  const scale = maxLongEdge / long;
  return {
    width: evenDimension(sw * scale),
    height: evenDimension(sh * scale),
  };
}
